import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M1.43343 6.42163L2.3735 11.753C2.43744 12.1156 2.78321 12.3577 3.14581 12.2938L6.76052 11.6564M1.43343 6.42163L1.10008 4.5311C1.03615 4.16851 1.27826 3.82274 1.64086 3.7588L9.51932 2.36961C9.88191 2.30568 10.2277 2.54779 10.2916 2.91039L10.625 4.80091L1.43343 6.42163ZM10.6666 7.77171V9.33171L12.0533 10.7184M14.9999 9.33171C14.9999 11.7249 13.0598 13.665 10.6666 13.665C8.27338 13.665 6.33328 11.7249 6.33328 9.33171C6.33328 6.93847 8.27338 4.99838 10.6666 4.99838C13.0598 4.99838 14.9999 6.93847 14.9999 9.33171Z",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }